import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pedal-selection" }
const _hoisted_2 = { class: "pedal-selection__filters" }
const _hoisted_3 = { class: "pedal-selection__content" }
const _hoisted_4 = { class: "pedal-selection__buttons" }

import { ref } from 'vue'
import { usePedalStore } from '@/store/pedalStore'
import { useMeasurementStore } from '@/store/measurementStore'
import { useRouter } from 'vue-router'
import PedalFilters from '@/components/setup/pedal/PedalFilters.vue'
import PedalSelection from '@/components/setup/pedal/PedalSelection.vue'
import { ButtonState, ButtonType, BfButton } from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'PedalSelectionView',
  setup(__props) {

const { t } = useI18n()
const router = useRouter()
const pedalStore = usePedalStore()
const measurementStore = useMeasurementStore()
const selected = ref()

pedalStore.reset()

const select = (pedal: any) => {
  selected.value = pedal
}

const cancel = () => {
  router.push({
    name: router.currentRoute.value.meta.update ? 'analysis' : 'setup',
  })
}

const install = () => {
  if (measurementStore.selectedMeasurement) {
    measurementStore.selectedMeasurement.pedal.active = selected.value
  }

  router.push({
    name: router.currentRoute.value.meta.update ? 'analysis' : 'setup',
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PedalFilters)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", null, _toDisplayString(_unref(t)('setup.pedal.selection')), 1),
      _createVNode(PedalSelection, { onSelect: select }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(BfButton), {
          type: _unref(ButtonType).Outlined,
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_unref(BfButton), {
          state: selected.value ? _unref(ButtonState).Enabled : _unref(ButtonState).Disabled,
          onClick: install
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('common.install')), 1)
          ]),
          _: 1
        }, 8, ["state"])
      ])
    ])
  ]))
}
}

})